var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11348_7811",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#E5F6EA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11348_7811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3691 12.2595H35.5498C37.7509 12.2597 39.539 14.0476 39.5391 16.2488V47.1755C39.539 49.3767 37.7509 51.1646 35.5498 51.1648H12.9863C11.5111 51.1647 10.225 50.3668 9.54102 49.1785L9.41211 48.9353L9.41016 48.9304L9.31641 48.7283C9.11048 48.2501 8.99708 47.7247 8.99707 47.1755V23.1072L9.00098 22.9187C9.00962 22.7311 9.03194 22.548 9.06934 22.3718L9.07129 22.363L9.07227 22.3542C9.10469 22.17 9.1534 21.9865 9.21777 21.8103L9.28809 21.6375L9.29199 21.6267L9.29688 21.615C9.50107 21.0825 9.83001 20.5965 10.2666 20.1892L10.2676 20.1902L17.6914 13.2986L17.6904 13.2976C18.0858 12.9314 18.5648 12.6523 19.0723 12.4832L19.0898 12.4773C19.3137 12.3934 19.5575 12.3342 19.8096 12.2966C20.0032 12.2735 20.1888 12.2595 20.3691 12.2595Z",
    fill: "white",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0408 16.2505V47.1772C40.0408 49.6546 38.029 51.6665 35.5516 51.6665H12.9885C11.6666 51.6665 10.4861 51.1012 9.66309 50.195C10.1867 50.4112 10.7689 50.5358 11.3757 50.5358H33.9386C36.416 50.5358 38.428 48.524 38.428 46.0465V15.1199C38.428 13.956 37.9874 12.9002 37.264 12.1021C38.8935 12.7755 40.0408 14.38 40.0408 16.2505Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2756 14.2525H22.605C22.2607 14.2525 21.9814 13.9732 21.9814 13.629C21.9814 13.2848 22.2607 13.0055 22.605 13.0055H23.2756C23.6198 13.0055 23.8991 13.2848 23.8991 13.629C23.8991 13.9732 23.6198 14.2525 23.2756 14.2525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2317 14.2529H25.7221C25.3779 14.2529 25.0986 13.9736 25.0986 13.6294C25.0986 13.2851 25.3779 13.0059 25.7221 13.0059H30.2317C30.5759 13.0059 30.8552 13.2851 30.8552 13.6294C30.8552 13.9736 30.5759 14.2529 30.2317 14.2529Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.9134 12.0076V19.1932C18.9134 20.4315 17.9096 21.4353 16.6714 21.4353H8.8291C9.06185 20.8284 9.43597 20.2796 9.92645 19.8224L17.3505 12.9305C17.7994 12.5148 18.3398 12.1988 18.9134 12.0076Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0865 36.0353C10.3446 36.0353 10.5539 35.8259 10.5539 35.5679V28.162C10.5539 27.9039 10.3446 27.6946 10.0865 27.6946C9.82849 27.6946 9.61914 27.9039 9.61914 28.162V35.5679C9.61914 35.8259 9.82849 36.0353 10.0865 36.0353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0865 26.6799C10.3446 26.6799 10.5539 26.4706 10.5539 26.2125V25.7104C10.5539 25.4524 10.3446 25.243 10.0865 25.243C9.82849 25.243 9.61914 25.4524 9.61914 25.7104V26.2125C9.61914 26.4706 9.82849 26.6799 10.0865 26.6799Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.4066 47.2084C17.4066 47.5826 17.1074 47.8818 16.7332 47.8818H13.441C13.067 47.8818 12.7676 47.5826 12.7676 47.2084C12.7676 46.8343 13.067 46.535 13.441 46.535H16.7332C17.1074 46.535 17.4066 46.8343 17.4066 47.2084Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4401 37.2653C35.4401 37.6394 35.1409 37.9387 34.7668 37.9387H23.6182C23.2525 37.9387 22.9531 37.6394 22.9531 37.2653C22.9531 36.8912 23.2525 36.5919 23.6182 36.5919H34.7668C35.1409 36.5919 35.4401 36.8912 35.4401 37.2653Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7633 27.3226C35.7633 27.6967 35.4639 27.996 35.0899 27.996H31.9723C31.5982 27.996 31.2988 27.6967 31.2988 27.3226C31.2988 26.9484 31.5982 26.6492 31.9723 26.6492H35.0899C35.4639 26.6492 35.7633 26.9484 35.7633 27.3226Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.763 33.9481C35.763 34.3222 35.4636 34.6215 35.0895 34.6215H13.441C13.067 34.6215 12.7676 34.3222 12.7676 33.9481C12.7676 33.5823 13.067 33.2747 13.441 33.2747H35.0895C35.4636 33.2747 35.763 33.5823 35.763 33.9481Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4386 40.5826C35.4386 40.9484 35.1395 41.256 34.7654 41.256H13.441C13.067 41.256 12.7676 40.9484 12.7676 40.5826C12.7676 40.2085 13.067 39.9092 13.441 39.9092H34.7654C35.1395 39.9092 35.4386 40.2085 35.4386 40.5826Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7676 37.2653C12.7676 36.8912 13.067 36.5919 13.441 36.5919H19.5078C19.8735 36.5919 20.1729 36.8912 20.1729 37.2653C20.1729 37.6394 19.8735 37.9387 19.5078 37.9387H13.441C13.067 37.9387 12.7676 37.6394 12.7676 37.2653Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7676 43.8914C12.7676 43.5256 13.067 43.218 13.441 43.218H27.5408C27.915 43.218 28.2142 43.5256 28.2142 43.8914C28.2142 44.2655 27.915 44.5648 27.5408 44.5648H13.441C13.067 44.5648 12.7676 44.2655 12.7676 43.8914Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7676 30.6393C12.7676 30.2652 13.067 29.9659 13.441 29.9659H17.7391C18.105 29.9659 18.4125 30.2652 18.4125 30.6393C18.4125 31.0135 18.105 31.3127 17.7391 31.3127H13.441C13.067 31.3127 12.7676 31.0135 12.7676 30.6393Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4429 43.8914C35.4429 44.2655 35.1437 44.5648 34.7697 44.5648H30.9703C30.5963 44.5648 30.2969 44.2655 30.2969 43.8914C30.2969 43.5256 30.5963 43.218 30.9703 43.218H34.7697C35.1437 43.218 35.4429 43.5256 35.4429 43.8914Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7639 30.6395C35.7639 31.0136 35.4646 31.3129 35.0905 31.3129H21.2984C20.9325 31.3129 20.625 31.0136 20.625 30.6395C20.625 30.2653 20.9325 29.9661 21.2984 29.9661H35.0905C35.4646 29.9661 35.7639 30.2653 35.7639 30.6395Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7676 24.0137C12.7676 23.6396 13.067 23.3403 13.441 23.3403H35.0895C35.4636 23.3403 35.763 23.6396 35.763 24.0137C35.763 24.3795 35.4636 24.6871 35.0895 24.6871H13.441C13.067 24.6871 12.7676 24.3795 12.7676 24.0137Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7676 27.3222C12.7676 26.9481 13.067 26.6488 13.441 26.6488H26.327C26.7013 26.6488 27.0005 26.9481 27.0005 27.3222C27.0005 27.6963 26.7013 27.9956 26.327 27.9956H13.441C13.067 27.9956 12.7676 27.6963 12.7676 27.3222Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3564 47.2086C28.3564 47.5827 28.0489 47.882 27.6831 47.882H21.3314C20.9657 47.882 20.6582 47.5827 20.6582 47.2086C20.6582 46.8344 20.9657 46.5352 21.3314 46.5352H27.6831C28.0489 46.5352 28.3564 46.8344 28.3564 47.2086Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8896 45.0918L35.4832 39.6854L33.4039 41.7648L38.8103 47.1712L40.8896 45.0918Z",
    fill: "#798393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3416 48.6301C42.205 48.7667 42.0429 48.875 41.8645 48.949C41.686 49.0229 41.4948 49.0609 41.3016 49.0609C41.1085 49.0609 40.9172 49.0229 40.7388 48.949C40.5603 48.875 40.3982 48.7667 40.2616 48.6301L38.8058 47.1742L40.8857 45.0942L42.3416 46.5501C42.4782 46.6867 42.5866 46.8488 42.6605 47.0272C42.7344 47.2057 42.7725 47.3969 42.7725 47.5901C42.7725 47.7832 42.7344 47.9745 42.6605 48.1529C42.5866 48.3314 42.4782 48.4935 42.3416 48.6301Z",
    fill: "#FFE07D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4194 44.355C26.1961 44.355 22.7725 40.9313 22.7725 36.708C22.7725 32.4847 26.1961 29.061 30.4194 29.061C34.6427 29.061 38.0664 32.4847 38.0664 36.708C38.0664 40.9313 34.6427 44.355 30.4194 44.355Z",
    fill: "#8A94A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4196 42.2961C27.3334 42.2961 24.8315 39.7942 24.8315 36.7079C24.8315 33.6217 27.3334 31.1198 30.4196 31.1198C33.5059 31.1198 36.0078 33.6217 36.0078 36.7079C36.0078 39.7942 33.5059 42.2961 30.4196 42.2961Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0783 33.1968C27.1502 32.3267 28.5065 31.8846 29.8853 31.9561C31.2641 32.0275 32.5675 32.6074 33.5437 33.5836C34.5199 34.5599 35.0998 35.8632 35.1712 37.242C35.2427 38.6208 34.8007 39.9771 33.9306 41.049C32.8586 41.9191 31.5023 42.3611 30.1235 42.2897C28.7448 42.2182 27.4414 41.6384 26.4652 40.6622C25.4889 39.6859 24.9091 38.3825 24.8376 37.0038C24.7662 35.625 25.2082 34.2687 26.0783 33.1968Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8613 39.0608C30.8613 39.1778 30.8148 39.29 30.7321 39.3728C30.6494 39.4555 30.5372 39.502 30.4202 39.502H25.582C25.4194 39.2203 25.2817 38.9251 25.1702 38.6196H30.4202C30.5372 38.6196 30.6494 38.6661 30.7321 38.7488C30.8148 38.8316 30.8613 38.9438 30.8613 39.0608Z",
    fill: "#A8A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8486 36.2668H32.1838C32.3008 36.2668 32.413 36.3133 32.4958 36.3961C32.5785 36.4788 32.625 36.591 32.625 36.708C32.625 36.825 32.5785 36.9372 32.4958 37.02C32.413 37.1027 32.3008 37.1492 32.1838 37.1492H24.8486C24.8369 37.0039 24.831 36.8551 24.831 36.708C24.831 36.561 24.8369 36.4139 24.8486 36.2668Z",
    fill: "#A8A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.625 34.355C32.625 34.472 32.5785 34.5842 32.4958 34.6669C32.413 34.7497 32.3008 34.7962 32.1838 34.7962H25.1692C25.2804 34.4906 25.4182 34.1953 25.581 33.9138H32.1838C32.3008 33.9138 32.413 33.9603 32.4958 34.043C32.5785 34.1258 32.625 34.238 32.625 34.355Z",
    fill: "#A8A6A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.c8e3c17e0ea7525b238ad7d06a6a4c90.svg";
export { ForwardRef as ReactComponent };